// src/pages/SorteadorAoVivo.jsx

import React, { useEffect, useMemo, useState } from "react";
import axios from "../axiosConfig";
import { useNavigate, useParams } from "react-router-dom";
import { Gift, LogOut, PartyPopper, RefreshCcw, Trophy } from "lucide-react";
import "./SorteadorAoVivo.css";

function SorteadorAoVivo() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const [revelacao, setRevelacao] = useState(null);

  const [mostrarCadastro, setMostrarCadastro] = useState(false);
  const [novoLead, setNovoLead] = useState({
    nome: "",
    empresa: "",
    email: "",
    whatsapp: ""
  });

  const token = sessionStorage.getItem("sorteador_token");

  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${token}`
    }),
    [token]
  );

  const sair = () => {
    sessionStorage.removeItem("sorteador_token");
    sessionStorage.removeItem("sorteador_slug");
    sessionStorage.removeItem("sorteador_titulo");
    navigate(`/sorteador-login?slug=${slug}`);
  };

  const carregarStatus = async () => {
    if (!token) {
      navigate(`/sorteador-login?slug=${slug}`);
      return;
    }

    setMensagem("");

    try {
      const { data } = await axios.get(`/sorteador/${slug}/status`, { headers });
      setStatus(data);
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível carregar o sorteador."
      );

      if ([401, 403].includes(err.response?.status)) {
        setTimeout(() => sair(), 1200);
      }
    }
  };

  useEffect(() => {
    carregarStatus();
    
  }, [slug]);

  const iniciarContagem = () => {
    return new Promise((resolve) => {
      let valor = 5;
      setCountdown(valor);

      const timer = setInterval(() => {
        valor -= 1;

        if (valor <= 0) {
          clearInterval(timer);
          setCountdown(null);
          resolve();
        } else {
          setCountdown(valor);
        }
      }, 1000);
    });
  };

  const sortearProximo = async () => {
    if (loading || status?.encerrado) return;

    setLoading(true);
    setMensagem("");
    setRevelacao(null);

    try {
      await iniciarContagem();

      const { data } = await axios.post(
        `/sorteador/${slug}/sortear-proximo`,
        {},
        { headers }
      );

      setRevelacao(data);
      await carregarStatus();
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível sortear o próximo prêmio."
      );
    } finally {
      setLoading(false);
    }
  };

  const premioAtual = status?.premio_atual;

  const refazerSorteio = async (premio) => {
  const ok = window.confirm(
    `Cancelar o resultado de ${premio.ganhador_nome} e sortear novamente o prêmio "${premio.nome_premio}"?\n\nO participante será eliminado dos próximos sorteios.`
  );

  if (!ok) return;

  setMensagem("");

  try {
    await axios.post(
      `/sorteador/${slug}/premios/${premio.id}/refazer`,
      { motivo: "Participante ausente no momento do sorteio." },
      { headers }
    );

    setMensagem("Resultado cancelado. O prêmio pode ser sorteado novamente.");
    await carregarStatus();
  } catch (err) {
    setMensagem(err.response?.data?.error || "Não foi possível refazer o sorteio.");
  }
};

  const cadastrarParticipante = async (e) => {
  e.preventDefault();
  setMensagem("");

  if (!novoLead.nome || !novoLead.email || !novoLead.whatsapp) {
    setMensagem("Informe nome, e-mail e WhatsApp.");
    return;
  }

  try {
    await axios.post(
      `/sorteador/${slug}/participantes`,
      novoLead,
      { headers }
    );

    setNovoLead({
      nome: "",
      empresa: "",
      email: "",
      whatsapp: ""
    });

    setMostrarCadastro(false);
    setMensagem("Participante cadastrado com sucesso.");
    await carregarStatus();
  } catch (err) {
    setMensagem(
      err.response?.data?.error ||
        "Não foi possível cadastrar o participante."
    );
  }
};

  return (
    <div className="sorteadorAoVivo-page">
      {countdown && (
        <div className="sorteadorAoVivo-countOverlay">
          <div className="sorteadorAoVivo-ring" />
          <div className="sorteadorAoVivo-ring two" />
          <strong>{countdown}</strong>
          <span>Sorteando...</span>
        </div>
      )}

      {revelacao && (
        <div className="sorteadorAoVivo-reveal" onClick={() => setRevelacao(null)}>
          <Trophy size={82} />
          <span>Ganhador(a)</span>
          <h1>{revelacao.ganhador?.nome}</h1>
          <p>{revelacao.ganhador?.empresa || "Parabéns!"}</p>
          <small>Prêmio: {revelacao.premio?.nome_premio}</small>
          <button type="button">Continuar</button>
        </div>
      )}

      <header className="sorteadorAoVivo-header">
        <div>
          <span>Sorteador Tikpag</span>
          <h1>{status?.sorteio?.titulo || "Carregando sorteio..."}</h1>
          <p>{status?.total_participantes || 0} participante(s) cadastrados</p>
        </div>

        <button type="button" onClick={sair}>
          <LogOut size={17} />
          Sair
        </button>
      </header>

      {mensagem && (
        <div className="sorteadorAoVivo-message">
          {mensagem}
        </div>
      )}

      <main className="sorteadorAoVivo-main">
        <section className="sorteadorAoVivo-current">
          <div className="sorteadorAoVivo-currentIcon">
            <Gift size={42} />
          </div>

          <span>Prêmio atual</span>

          {premioAtual ? (
            <>
              <h2>{premioAtual.nome_premio}</h2>
              <p>{premioAtual.descricao || "Este será o próximo prêmio sorteado."}</p>

              {premioAtual.imagem_url && (
                <img src={premioAtual.imagem_url} alt={premioAtual.nome_premio} />
              )}
            </>
          ) : (
            <>
              <h2>Sorteio encerrado</h2>
              <p>Todos os prêmios disponíveis já foram sorteados.</p>
            </>
          )}

          <button
            type="button"
            onClick={sortearProximo}
            disabled={loading || !premioAtual || status?.encerrado}
          >
            <PartyPopper size={21} />
            {loading
              ? "Sorteando..."
              : !premioAtual || status?.encerrado
                ? "Sorteio encerrado"
                : "Sortear este prêmio"}
          </button>
        </section>

        <aside className="sorteadorAoVivo-side">
          <div className="sorteadorAoVivo-sideHeader">
            <div>
              <h3>Prêmios</h3>
              <span>
                {(status?.premios || []).filter((p) => Number(p.sorteado) === 1).length}/
                {status?.premios?.length || 0} sorteados
              </span>
            </div>

            <button type="button" onClick={carregarStatus}>
              <RefreshCcw size={15} />
            </button>
          </div>

          <div className="sorteadorAoVivo-premios">
            {(status?.premios || []).map((premio) => (
              <div
                key={premio.id}
                className={`sorteadorAoVivo-premio ${
                  Number(premio.sorteado) === 1 ? "done" : "pending"
                }`}
              >
                <strong>#{premio.ordem}</strong>

                <div>
                  <span>{premio.nome_premio}</span>
                  {Number(premio.sorteado) === 1 ? (
                    <small>{premio.ganhador_nome || "Sorteado"}</small>
                  ) : (
                    <small>Aguardando sorteio</small>
                  )}
                </div>
              </div>
            ))}
          </div>
        </aside>

            <section className="sorteadorAoVivo-bottom">
  <div className="sorteadorAoVivo-panel">
    <div className="sorteadorAoVivo-panelHeader">
      <div>
        <h3>Participantes</h3>
        <span>{status?.participantes_lista?.length || 0} pessoa(s)</span>
      </div>

      <button
        type="button"
        onClick={() => setMostrarCadastro((prev) => !prev)}
      >
        {mostrarCadastro ? "Fechar cadastro" : "Cadastrar participante"}
      </button>
    </div>

    {mostrarCadastro && (
      <form className="sorteadorAoVivo-cadastro" onSubmit={cadastrarParticipante}>
        <input
          placeholder="Nome"
          value={novoLead.nome}
          onChange={(e) => setNovoLead((p) => ({ ...p, nome: e.target.value }))}
        />

        <input
          placeholder="Empresa"
          value={novoLead.empresa}
          onChange={(e) => setNovoLead((p) => ({ ...p, empresa: e.target.value }))}
        />

        <input
          placeholder="E-mail"
          value={novoLead.email}
          onChange={(e) => setNovoLead((p) => ({ ...p, email: e.target.value }))}
        />

        <input
          placeholder="WhatsApp"
          value={novoLead.whatsapp}
          onChange={(e) => setNovoLead((p) => ({ ...p, whatsapp: e.target.value }))}
        />

        <button type="submit">Salvar participante</button>
      </form>
    )}

    <div className="sorteadorAoVivo-listaParticipantes">
      {(status?.participantes_lista || []).map((pessoa, index) => (
        <div key={pessoa.id} className="sorteadorAoVivo-participante">
          <strong>{index + 1}</strong>
          <div>
            <span>{pessoa.nome}</span>
            <small>{pessoa.empresa || pessoa.email}</small>
          </div>
        </div>
      ))}
    </div>
  </div>

  <div className="sorteadorAoVivo-panel">
    <div className="sorteadorAoVivo-panelHeader">
      <div>
        <h3>Ganhadores</h3>
        <span>
          {(status?.premios || []).filter((p) => Number(p.sorteado) === 1).length} sorteado(s)
        </span>
      </div>
    </div>

    <div className="sorteadorAoVivo-listaGanhadores">
      {(status?.premios || [])
          .filter((premio) => Number(premio.sorteado) === 1)
          .map((premio) => (
            <div key={premio.id} className="sorteadorAoVivo-ganhador">
              <Trophy size={18} />

              <div>
                <strong>{premio.ganhador_nome}</strong>
                <span>{premio.nome_premio}</span>
              </div>

              <button
                type="button"
                onClick={() => refazerSorteio(premio)}
                className="sorteadorAoVivo-refazerBtn"
              >
                Refazer sorteio
              </button>
            </div>
        ))}

      {(status?.premios || []).filter((p) => Number(p.sorteado) === 1).length === 0 && (
        <div className="sorteadorAoVivo-semGanhadores">
          Nenhum ganhador ainda.
        </div>
      )}
    </div>
  </div>
</section>

      </main>
    </div>
  );
}

export default SorteadorAoVivo;